  
export function formatCurrency(value) {
  if (!value) return value;
  return (value / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
}

export function formatDateTime(value) {
  if (!value) return value;
  const date = value.replace(/[^\d]/g, '');
  const dateLength = date.length;
  const m = date.slice(4, 5)=='0' ? date.slice(5, 6) : date.slice(4, 6);
  const d = date.slice(6, 7)=='0' ? date.slice(7, 8) : date.slice(6, 8);
  const y = date.slice(0, 4);
  return `${m}/${d}/${y}`;
}

export function formatDate(value) {
  if (!value) return value;
  const date = value.replace(/[^\d]/g, '');
  const dateLength = date.length;
  if (dateLength < 3) return date;
  if (dateLength < 5) {
    return `${date.slice(0, 2)}/${date.slice(2)}`;
  }
  return `${date.slice(0, 2)}/${date.slice(2,4)}/${date.slice(4, 8)}`;
}

export function formatTimestamp(value) {
  if (!value) return value;
  return new Date(value*1000).toLocaleDateString();
}

export function formatPhone(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3,6)}-${phoneNumber.slice(6, 10)}`;
}

export function formatNewlines(value, tag) {
  if (!value) return value;
  if (!tag) return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
  if (tag) return value.split(/\r?\n/).map(line => `<${ tag }>${ line }</${ tag }>`).join('');
}